import {observer} from 'mobx-react';
import React from 'react';
import {makeObservable} from 'mobx';
import s from '../../s';

type Props = {
    loading: boolean;
    label?: string;
    additionalClass?: string;
    clicked: () => Promise<void>;
};

@observer
export default class ATCButtonTemplate extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        makeObservable(this);
    }

    render() {
        const label = this.props.label || 'Add to cart';
        const {loading, additionalClass} = this.props;

        return (
            <>
                <div
                    aria-live="assertive"
                    aria-atomic="true"
                    className="sr-only"
                >
                    {loading ? 'Adding to cart, please wait...' : ''}
                </div>

                <button
                    className={`prod-atc-btn ${additionalClass || ''}${s.IsPortal3 ? ' portal3' : ''}`}
                    aria-label={label}
                    onClick={this.props.clicked}
                    disabled={loading}
                    aria-busy={loading}
                    type="button"
                >
                    {label}
                    {loading && (
                        <span
                            className="pad-left"
                            aria-hidden="true"
                        >
                            <i className="fas fa-circle-notch fa-spin fast-spin fa-checkout-button"></i>
                        </span>
                    )}
                </button>
            </>
        );
    }
}
